import { Controller } from "@hotwired/stimulus";

// Switch instructions in place; the one-time key stays visible and is never regenerated.
export default class extends Controller {
  static targets = ["choice", "panel"];

  connect() {
    this.select();
  }

  select() {
    const selected = this.choiceTargets.find((choice) => choice.checked)?.value;
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.client !== selected;
    });
  }
}
